import Home from "./pages/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import BottomNav from "./pages/BottomNav";
import { useState, useEffect } from "react";
import axios from "axios";

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [isMiniMobile, setIsMiniMobile] = useState(false);

  useEffect(() => {
    // Log visit to backend
    const logVisit = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_BASE_URI || "http://localhost:4000";
        await axios.post(`${backendUrl}/visitor/log-visit`, {
          userAgent: navigator.userAgent
        });
      } catch (err) {
        console.error("Failed to log visit:", err);
      }
    };
    logVisit();

    function handleResize() {
      setIsMobile(window.innerWidth < 968);
      setIsMiniMobile(window.innerWidth < 476);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return <>
    <Header />
    {(isMobile || isMiniMobile) && <BottomNav />}
    <Home />
    <Footer />
  </>;
}

export default App;
